import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../auth/auth.service";

@Component({
  selector: "app-site-name-logo",
  templateUrl: "./site-name-logo.component.html",
  styleUrls: ["./site-name-logo.component.scss"]
})
export class SiteNameLogoComponent implements OnInit {
  @Input() backGround: boolean = false;
  @Input() homeClick: boolean = false;
  homeAdd = "";
  target = "";
  constructor(
    public translate: TranslateService,
    private authSrv: AuthService
  ) {}

  ngOnInit() {
    if (this.homeClick) {
      if (this.authSrv.isAdminU()) {
        this.target = "_blank";
      }
      this.homeAdd = this.authSrv.goToHomeAdd();
    }
  }

  gotHome() {
    if (this.homeClick) {
      return this.authSrv.goToHome();
    }
  }
}
